import Input from '@ui/Input';
import SafeImage from '@ui/SafeImage';
import { FAQTopic, QUESTION_TOPIC_MAP } from '@util/maps/faq';
import { AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import dWeb from './images/helpcenter.png';
import { getFaqUrl } from '@util/urlHelpers';
import { useRouter } from '@bprogress/next';
import { MotionDiv } from 'motion';

function findFAQs(searchInput: string): { q: string; topic: FAQTopic }[] {
  const matchingQuestions = Object.keys(QUESTION_TOPIC_MAP).filter((q) => {
    const lowerCaseSearchInput = searchInput.toLowerCase().trim();
    const lowerCaseQuestion = q.toLowerCase();
    return lowerCaseQuestion.includes(lowerCaseSearchInput);
  });
  const results = matchingQuestions.map((q) => ({
    q,
    topic: QUESTION_TOPIC_MAP[q],
  }));
  return results;
}

const HelpCenterHeader = () => {
  return (
    <div className="relative h-[40rem] w-full overflow-x-clip bg-[#000000] sm:h-[50rem]">
      {/* image container */}
      <div className="relative mx-auto h-[40rem] sm:h-[50rem]">
        {/* smooth left */}
        <div className="bg absolute -left-20 z-10 hidden h-[40rem] w-[20rem] bg-gradient-to-r  from-[#000000] to-transparent xl:block" />
        {/* smooth right */}
        <div className="absolute -right-20 z-10 hidden h-[40rem] w-[20rem] bg-gradient-to-l from-[#000000] to-transparent xl:block" />
        {/* image */}
        <SafeImage
          alt={'help center header image'}
          className="object-cover"
          draggable={false}
          fill
          key={'help center header image'}
          src={dWeb}
          priority
        />
      </div>
      {/* content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <h1 className="text-4xl font-bold text-white sm:text-7xl">
          How can we help you?
        </h1>
        <SearchField />
        {/* search */}
      </div>
    </div>
  );
};

export const SearchField = () => {
  const [searchInput, setSearchInput] = useState('');
  const [focus, setFocus] = useState(false);
  const results = findFAQs(searchInput);
  const router = useRouter();
  function navigate(topic: FAQTopic, q: string) {
    const href = getFaqUrl(topic, q);
    router.push(href);
  }
  return (
    <div className="mt-[2.4rem] w-full max-w-[38rem] sm:mt-[4rem] sm:max-w-[60rem]">
      <Input
        type="search"
        placeholder="Search MX Locker help center"
        full
        onChange={(e) => setSearchInput(e.target.value)}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        className="!text-3xl"
      />
      <AnimatePresence>
        {focus && searchInput && (
          <MotionDiv
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            className="mt-[2rem] h-fit w-full cursor-pointer overflow-clip rounded-[1rem] border border-brand-darker-white bg-brand-white shadow-lg"
          >
            <div className="flex max-h-[25rem] flex-col overflow-y-scroll">
              {!!results.length &&
                results.map((result, i) => (
                  <div
                    key={i}
                    className="w-full py-4 pl-8 text-left hover:bg-brand-darker-white"
                    onMouseDown={() => navigate(result.topic, result.q)}
                  >
                    {result.q}
                  </div>
                ))}
              {!results.length && (
                <div className="w-full py-4 pl-8 text-left">
                  No results found
                </div>
              )}
            </div>
          </MotionDiv>
        )}
      </AnimatePresence>
    </div>
  );
};

export default HelpCenterHeader;
